import { Lookup } from './lookup.interface';
export const EligibilityDecisions: { [name: string]: Lookup } = {
  Approved: { displayValue: 'Approved', code: 'Approved' },
  ApprovedOneTime: { displayValue: 'Approved - one time issue', code: 'ApprovedOneTime' },
  Denied: { displayValue: 'Denied', code: 'Denied' },
  Withdrawn: { displayValue: 'Withdrawn', code: 'Withdrawn' },
  Duplicate: { displayValue: 'Duplicate', code: 'Duplicate' },
};
